import React from "react";
import inputHandler from "../../../utils/inputHandler";
import { checkSpecialRequirement, isCurrentLevel } from "./questionValidator";
import GridComponent from "../GridComponent/GridComponent";
const PARENT = "Parent";

export default function QuestionContainer(props) {
	const { questions, formData = {}, currentDisplayedForm, formLevel, globalFormData = {} } = props;
	const data = { formData, parentFormData: globalFormData };

	const shouldNotRender = (question) => {
		return !checkSpecialRequirement(question, data);
	};

	const shouldRender = (question) => {
		return checkSpecialRequirement(question, data);
	};

	const componentChildren = questions.find((question) => {
		if (shouldRender(question)) {
			return question.type === "Parent";
		}
		return null;
	});

	const questionary = questions.filter((question) => question.type !== "Parent");

	const componentChildrenGridComponent = componentChildren && (
		<GridComponent {...props} Input={inputHandler(PARENT)} data={componentChildren} />
	);

	return (
		<>
			{isCurrentLevel(currentDisplayedForm, formLevel) &&
				questionary.map((question, index) => {
					const Input = inputHandler(question.type);
					if (!Input || shouldNotRender(question)) return null;
					return <GridComponent key={`${index}${question.id}`} {...props} Input={Input} data={question} />;
				})}
			{componentChildrenGridComponent}
		</>
	);
}
